import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ClearIcon from '@mui/icons-material/Clear';

const MODULE_OPTIONS = [
  'All',
  'Routes',
  'Holdings',
  'Catalog',
  'Orders',
  'Updates',
  'Transfers',
  'System',
];
const STATUS_OPTIONS = ['All', 'succeeded', 'failed', 'running', 'pending', 'cancelled', 'blocked'];

interface Props {
  module: string;
  status: string;
  search: string;
  correlationId: string;
  operationId: string;
  onModuleChange: (v: string) => void;
  onStatusChange: (v: string) => void;
  onSearchChange: (v: string) => void;
  onCorrelationIdChange: (v: string) => void;
  onOperationIdChange: (v: string) => void;
  onClear: () => void;
}

export default function ActivityFilters({
  module,
  status,
  search,
  correlationId,
  operationId,
  onModuleChange,
  onStatusChange,
  onSearchChange,
  onCorrelationIdChange,
  onOperationIdChange,
  onClear,
}: Props) {
  const hasFilters =
    module !== '' || status !== '' || search !== '' || correlationId !== '' || operationId !== '';

  return (
    <div data-testid="activity-filters">
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center' }}>
        <TextField
          select
          label="Module"
          size="small"
          value={module || 'All'}
          onChange={(e) => onModuleChange(e.target.value === 'All' ? '' : e.target.value)}
          sx={{ minWidth: 130 }}
        >
          {MODULE_OPTIONS.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label="Status"
          size="small"
          value={status || 'All'}
          onChange={(e) => onStatusChange(e.target.value === 'All' ? '' : e.target.value)}
          sx={{ minWidth: 120 }}
        >
          {STATUS_OPTIONS.map((opt) => (
            <MenuItem key={opt} value={opt} sx={{ textTransform: 'capitalize' }}>
              {opt}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Search"
          size="small"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Entity, actor, action..."
          sx={{ minWidth: 180 }}
        />

        <TextField
          label="Correlation ID"
          size="small"
          value={correlationId}
          onChange={(e) => onCorrelationIdChange(e.target.value)}
          placeholder="01H-..."
          sx={{ minWidth: 150 }}
        />

        <TextField
          label="Operation ID"
          size="small"
          value={operationId}
          onChange={(e) => onOperationIdChange(e.target.value)}
          placeholder="op-..."
          sx={{ minWidth: 150 }}
        />

        {hasFilters && (
          <Button
            size="small"
            startIcon={<ClearIcon />}
            onClick={onClear}
            sx={{ textTransform: 'none' }}
          >
            Clear
          </Button>
        )}
      </Box>
    </div>
  );
}
